import CollectionList from "../Collections/CollectionList";

export {SavingState as default};

/**
* Saving State
*
* @author      rsimoes <ruben-r-simoes@telecom.pt>
* @copyright   Copyright (C) Sapo. All rights reserved.
* @license     Private
* @since       7.0.0
*/
class SavingState {
  /**
   * Defines an id beeing saved
   *
   * @public
   *
   * @since 7.0.0
   *
   * @type {Object}
   */
  saving = {};

  /**
   * Adds an id to the saving state
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} id saving id
   *
   * @return {void}
   */
  setSaving(id) {
    this.saving[id] = true;
  }

  /**
   * Adds an array of ids to the saving state
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} id_prefix saving id prefix
   * @param {Array}  ids       list ids
   *
   * @return {void}
   */
  setSavingArray(id_prefix, ids) {
    ids.forEach((id) => {
      this.setSaving(id_prefix + id);
    });
  }

  /**
   * Removes an array of ids from the saving state
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {String} id_prefix saving id prefix
   * @param {Array}  ids       list ids
   *
   * @return {void}
   */
  unsetSavingArray(id_prefix, ids) {
    ids.forEach((id) => {
      this.unsetSaving(id_prefix + id);
    });
  }

  /**
   * Deletes an id from the saving state
   *
   * @public
   *
   * @since 7.0.0
   *
   * @param {Object} id saving id
   *
   * @return {void}
   */
  unsetSaving(id) {
    delete this.saving[id];
  }
}